// reducer.js
import * as actionTypes from "./actionsTypes";

const initialState = {
  currentPage: 1,
  value: "",
  statut:"",
  sortField: "creee_le",
  order: "desc",
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_CURRENT_PAGE_SUIVI:
      return {
        ...state,
        currentPage: action.payload
      };
    case actionTypes.SET_VALUE_SUIVI:
      return {
        ...state,
        value: action.payload
      };
    case actionTypes.SET_SORT_FIELD_SUIVI:
      return {
        ...state,
        sortField: action.payload
      };
    case actionTypes.SET_ORDER_SUIVI:
      return {
        ...state,
        order: action.payload
      };
      case actionTypes.SET_STATUT_SUIVI:
        return {
          ...state,
          statut: action.payload
        };
    default:
      return state;
  }
};

export default rootReducer;
